import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Menu, Dropdown, Badge, Avatar, List } from 'antd';
import {
  MailOutlined,
  BellOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  MessageOutlined,
  CustomerServiceOutlined
} from '@ant-design/icons';
import Flex from 'components/shared-components/Flex'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { readAllNotification, selectHomePageNotificationList, selectUnreadNotificationCount } from 'utils/redux/actions/notiificationActions';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from 'constants/ApiConstant';
import * as signalR from '@microsoft/signalr';
import { FIRM_ID } from 'constants/StorageConstant';
const firmId = localStorage.getItem(FIRM_ID);


let hubConnection = null;


export const NavNotification = (props) => {
  let navigate = useNavigate();

  const isInitialRef = useRef(true);
  const [visible, setVisible] = useState(false);
  const [items, setItems] = useState([]);


  const handleVisibleChange = (flag) => {
    setVisible(flag);
    selectReadNotifications();
  }

  useEffect(() => {

    if (isInitialRef.current) {
      isInitialRef.current = false;
      selectNotificationList();
      selectUnreadNotificationCount();

    }


  }, []);

  useEffect(() => {
    if (!hubConnection) {
      hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_BASE_URL}/messagehub`)
        .withAutomaticReconnect()
        .build();

      const startConnection = async () => {
        try {
          await hubConnection.start();
          console.log('SignalR Connected');
        } catch (err) {
          console.error('SignalR Connection Error:', err);
          setTimeout(startConnection, 2000);
        }
      };

      hubConnection.onclose(() => {
        console.log('SignalR Connection Closed');
        setTimeout(startConnection, 2000);
      });

      startConnection();
    }


    hubConnection.off('whatsappListener_'+firmId , onNotificationCallBack);
    hubConnection.on('whatsappListener_'+ firmId, onNotificationCallBack);

    return () => {
      hubConnection.off('whatsappListener_'+firmId , onNotificationCallBack);
    };
  }, []);




  const onNotificationCallBack = useCallback(async (data) => {

    let newModel = {};
    let parsedData = JSON.parse(data.payload);

    console.log("--- NOTIFICATION ----")

    newModel.destinationuserid = parsedData.DESTINATONUSERID;
    newModel.fromuserid = parsedData.FROMUSERID;
    newModel.header = parsedData.HEADER;
    newModel.image = parsedData.IMAGE;
    newModel.isread = parsedData.ISREAD;
    newModel.text = parsedData.TEXT;

    setItems((state) => [...state, newModel]);

    selectNotificationList();
    selectUnreadNotificationCount();


    console.log("NotificationData", data);
    console.log(" --- NOTIFICATION END ----")
  }, []);


  const selectNotificationList = async () => {

    props.selectHomePageNotificationListActions();

  }
  const selectUnreadNotificationCount = async () => {

    props.selectUnreadNotificationCountActions();

  }

  const selectReadNotifications = async () => {

    props.selectReadNotificationActions();

  }

  const gotoNotification = () => {

    setVisible(false);
    navigate(`/notifications`)
  }

  const handleNotificationClick = (notification) => {
    setVisible(false);
    if (notification.header === "Yeni Görüş ve Öneri") {
      navigate('/feedback-page');
    } else if (notification.header === "Yeni Canlı Destek Bağlantısı") {
      navigate('/chat');
    }
  }

  const getIcon = icon => {
    switch (icon) {
      case 'mail':
        return <MailOutlined />;
      case 'alert':
        return <WarningOutlined />;
      case 'check':
        return <CheckCircleOutlined />
      case 'feedback':
        return <MessageOutlined />;
      case 'chat':
        return <CustomerServiceOutlined />;
      default:
        return <MailOutlined />;
    }
  }


  const getNotificationBody = list => {

    return list.length > 0 ?
      <List
        size="small"
        itemLayout="horizontal"
        dataSource={list}
        renderItem={item => (
          <List.Item className="list-clickable">
            <Flex alignItems="start" justifyContent='between' className='w-100' >
              <div className="pr-3">
                <Avatar className={`ant-avatar-info`} icon={getIcon("mail")} />
              </div>
              <div className="mr-3">
                <span className="font-weight-bold text-dark">{item.header} </span>
                <br></br>
                <span className="text-gray-light" style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineBreak: 2,
                  lineClamp: 2,
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical"
                }}>
                  {item.text}
                </span>
              </div>
              <small className="ml-auto">{item.senddateformat}</small>
            </Flex>
          </List.Item>
        )}
      />
      :
      <div className="empty-notification">
        <img src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg" alt="empty" />
        <p className="mt-3">Bildiriminiz bulunmamaktadır</p>
      </div>;
  }

  // Bildirimleri items dizisine dönüştür


  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        items: props.homePageNotifyList.length > 0 ? props.homePageNotifyList.map((notification, idx) => {
          let iconType = notification.icon || 'mail';
          if (notification.header === "Yeni Görüş ve Öneri") {
            iconType = 'feedback';
          } else if (notification.header === "Yeni Canlı Destek Bağlantısı") {
            iconType = 'chat';
          }
          return {
            key: idx + 1,
            onClick: () => handleNotificationClick(notification),
            label: (
              <span style={{
                display: 'flex',
                alignItems: 'center',
                opacity: notification.isread ? 0.6 : 1
              }}>
                <span style={{ marginRight: 8 }}>
                  {getIcon(iconType)}
                </span>
                <span style={{
                  flex: 1,
                  color: notification.isread ? '#bfbfbf' : '#222',
                  fontWeight: notification.isread ? 'normal' : 'bold',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {notification.header || notification.text || `Bildirim ${idx + 1}`}
                </span>
                <span style={{
                  marginLeft: 12,
                  fontSize: 12,
                  color: '#888'
                }}>
                  {new Date(notification.senddateformat).toLocaleDateString('tr-TR')} {new Date(notification.senddateformat).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                </span>
              </span>
            )
          }
        }) : [{
          key: 'no-notification',
          disabled: true,
          label: (
            <div className="empty-notification" style={{textAlign: "center", padding: "1rem"}}>
              <img src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg" alt="empty" />
              <p className="mt-3">Bildiriminiz bulunmamaktadır</p>
            </div>
          )
        }]
      }}
      onOpenChange={handleVisibleChange}
      trigger={['click']}
    >
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '36px',
          height: '36px',
          cursor: 'pointer'
        }}
      >
        <Badge count={props.unreadNotificationCount}>
          <BellOutlined className="nav-icon mx-auto" type="bell" style={{ fontSize: 20, lineHeight: 1 }} />
        </Badge>
      </span>
    </Dropdown>
  )
}


function mapStateToProps(state) {

  return {
    isLoading: state.notificationReducer.isLoading,
    homePageNotifyList: state.notificationReducer.homePageNotifyList,
    hasError: state.notificationReducer.hasError,
    errorMessage: state.notificationReducer.errorMessage,
    unreadNotificationCount: state.notificationReducer.unreadNotificationCount,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    selectHomePageNotificationListActions: bindActionCreators(selectHomePageNotificationList, dispatch),
    selectUnreadNotificationCountActions: bindActionCreators(selectUnreadNotificationCount, dispatch),
    selectReadNotificationActions:bindActionCreators(readAllNotification,dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavNotification);
